export default __webpack_public_path__ + "static/media/VN.a35fc20c.svg";